var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.564 1.91602H7.43732C4.79232 1.91602 3.83398 2.87435 3.83398 5.56727V17.4314C3.83398 20.1243 4.79232 21.0827 7.43732 21.0827H15.5544C18.209 21.0827 19.1673 20.1243 19.1673 17.4314V5.56727C19.1673 2.87435 18.209 1.91602 15.564 1.91602ZM11.5007 18.4952C10.5807 18.4952 9.82357 17.7381 9.82357 16.8181C9.82357 15.8981 10.5807 15.141 11.5007 15.141C12.4207 15.141 13.1777 15.8981 13.1777 16.8181C13.1777 17.7381 12.4207 18.4952 11.5007 18.4952ZM13.4173 5.98893H9.58398C9.19107 5.98893 8.86523 5.6631 8.86523 5.27018C8.86523 4.87727 9.19107 4.55143 9.58398 4.55143H13.4173C13.8102 4.55143 14.1361 4.87727 14.1361 5.27018C14.1361 5.6631 13.8102 5.98893 13.4173 5.98893Z",
    fill: "#14141F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoNumber);
export default __webpack_public_path__ + "static/media/trvto_number.5ef68e671d470b7a93f3c48288e5ddec.svg";
export { ForwardRef as ReactComponent };